import { initSummernote } from '../../summernote';
import { buildNoteForm } from './build_note_form';
import { toggleFormRow } from './toggle_form_row';

export function initNoteButtonListeners(insertedCellColSpan: number) {
  const wrapper = document.getElementById('candidates-table');
  if (!wrapper) return;

  wrapper.addEventListener('click', async (e: any) => {
    const target = e.target.closest('.notes-button');
    if (!target) {
      return;
    }

    e.preventDefault();
    e.stopPropagation(); // prevent bootstrap from firing toggle-event twice

    const row = target.closest('tr.gridjs-tr');
    if (!row) {
      return;
    }

    const noteFormRow = row.nextElementSibling;
    if (noteFormRow && noteFormRow.classList.contains('all-candidates-note-form')) {
      const noteCell = noteFormRow.querySelector('td');
      if (noteCell && noteCell.style.display !== 'none') {
        toggleFormRow(target, noteCell);
        noteFormRow.remove(); // remove existing note form for force-refetching on reopen
        return;
      }
    }

    const botsProspectId = row.querySelector('[data-bots-prospect-id]')?.getAttribute('data-bots-prospect-id');
    const botId = row.querySelector('[data-bot-id]')?.getAttribute('data-bot-id');
    if (!botsProspectId || !botId) {
      alert(botsProspectId ? 'Bot ID not found' : 'ID not found');
      return;
    }

    try {
      // disable trigger-button
      target.style.pointerEvents = 'none';
      target.style.opacity = '0.5';

      // start fetching note
      const requestPath = `/bots/${botId}/prospects/${botsProspectId}/notes`;
      const response = await fetch(requestPath, {
        headers: {
          'Accept': 'application/json'
        }
      });
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      // render new row with summernote beneath the current row
      const data = await response.json();
      const newRow = document.createElement('tr');
      const newCell = document.createElement('td');
      const noteForm = buildNoteForm(data.form_action, data.bots_prospect_id, data.notes);
      newCell.colSpan = insertedCellColSpan;
      newCell.appendChild(noteForm);
      newRow.appendChild(newCell);
      newRow.classList.add('all-candidates-note-form');
      newCell.style.display = 'none';
      row.after(newRow);
      toggleFormRow(target, newCell);
      initSummernote();
    } catch (error) {
      console.log(error);
      alert("Failed to load note form");
    } finally {
      // re-enable trigger-button
      target.style.pointerEvents = 'auto';
      target.style.opacity = '1';
    }
  });
}
